import script from "./BusinessAddressSetupStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessAddressSetupStep.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessAddressSetupStep.vue?vue&type=style&index=0&id=598ea231&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598ea231"]])

export default __exports__